import { ReactNode } from 'react';
import { createAction } from 'redux-act';

export interface GlobalModalOptions {
  isOpen: boolean;
  variant: 'info' | 'success' | 'error' | string;
  header: string;
  body: ReactNode;
  button: ReactNode;
  onClose: (meta: { actionButtonClicked: boolean }) => any;
  onButtonClick: (...args: any) => any;
}

export const setupModal = createAction<Partial<GlobalModalOptions>>('modal/MODAL_SETUP');

export const teardownModal = createAction('modal/MODAL_TEARDOWN');

export const displayModal = createAction('modal/MODAL_DISPLAY');
